<template>
  <div class="contentDetail">
    <!-- <button @click="goBack()">Go Back</button> -->
    <div v-if="isLoad === true">
      <div class="contentDetail__header">
      <div v-if="details.content_type !== 'video/mp4'">
        <div class="contentDetail__icon">
          <div v-if="details.content_type === 'application/x-zip-compressed' && details.category === 'Game'" class="mobibadge badge--html5">
            <img src="../../assets/cutehub/imgs/html5-badge.png"/>
          </div>
          <img :src="details.thumbnail_url" alt="" />
        </div>
      </div>
      <div v-else-if="details.content_type === 'video/mp4'">
        <div class="videoPlayer" v-if="auth_cutehub == 'loggedin'">
          <video :poster="details.cover_img" id="vidPlayer" playsinline controls>
            <source :src="details.file_url" type="video/mp4"/>
          </video>
        </div>
        <div class="dummyPlayer" v-if="auth_cutehub == 'guest' || auth_cutehub == ''">
          <div data-v-3e4079a0="" data-v-238dec4a="" class="playBtn" @click="subContent_cutehub([details.file_url, details.category])"><span data-v-3e4079a0="" data-v-238dec4a=""></span></div>
          <img :src="details.cover_img" alt="">
        </div>
      </div>
      <h1 class="mobiTitle lg" id="cont_name">{{getLanguage(lang_cutehub)}}</h1>
      <star-rating
        :inline="true"
        :star-size="24"
        :read-only="true"
        :increment="0.01"
        active-color="#ffc838"
        :show-rating="false"
        :border-width="2"
        border-color="#ffc838"
        :rounded-corners="false"
        inactive-color="transparent"
        :star-points="[
          23,
          2,
          14,
          17,
          0,
          19,
          10,
          34,
          7,
          50,
          23,
          43,
          38,
          50,
          36,
          34,
          46,
          19,
          31,
          17
        ]"
        :rating="Number(details.rating)"
        ></star-rating>
      </div>
      <div class="contentDetail__info">
        <ul v-if="isLoad === true">
          <li>{{ $t("category") }}: <span id="category"></span></li>
          <li>{{ $t("platform") }}: <span id="platform"></span></li>
          <!-- <li>{{ $t("type") }}: {{ details.content_type }}</li> -->
        </ul>
        <p class="mobitxt" id="description" v-if="isLoad === true"></p>
        <div class="contentDetails__screens">
          <ul>
            <li v-for="sc in details.screenshot" :key="sc.key" @click="openLightBox(sc)">
              <img :src="sc.url" alt="">
            </li>
          </ul>
        </div>
        <div class="mobiBtnContainer">
          <div v-if="details.category === 'Wallpaper'">
            <button class="mobiBtn" @click="subContent_cutehub([details.file_url, details.category, id])">
              <span>{{ $t("download") }}</span>
            </button>
          </div>
          <div v-if="details.category !== 'Wallpaper'">
            <div v-if="details.content_type === 'application/url'">
              <button class="mobiBtn" @click="subContent_cutehub([details.content_detail, details.content_type, id])">
                <span>{{ $t("play") }}</span>
              </button>
            </div>
            <div v-else>
              <button class="mobiBtn" @click="subContent_cutehub([details.raw_file_url, details.content_type, id])">
                <span v-if="details.content_type === 'application/x-zip-compressed'">{{ $t("play") }}</span>
                <span v-else>{{ $t("download") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentCover" :style="{ backgroundImage: 'url(' + contentCoverImg + ')' }"></div>
      <custom-lightbox
      :close="closeBox"
      :next="nextPic"
      :back="prevPic"
      :imgsource="lightBoxCurrentPic"
      v-if="lightBoxToggle"
    ></custom-lightbox>
  </div>
</template>
<style scoped>
.dummyPlayer{
  height: 420px;
  overflow: hidden;
  position: relative;
}

.dummyPlayer img{
  width: 100%;
}
</style>

<script>
import Vue from "vue";
import axios from "axios";
import Plyr from "plyr";
import cutehub from "../../router/cutehub";
import { mapActions, mapGetters } from "vuex";
import CustomLightbox from "./CustomLightbox.vue";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);

export default {
  data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false,
    };
  },
  components: {
    CustomLightbox,
    StarRating
  },
  computed: mapGetters(["lang_cutehub", "host_cutehub", "auth_cutehub", "country_cutehub"]),
  created() {
    this.getDetails(this.id);
  },
  mounted() {},
  methods: {
    ...mapActions(["subContent_cutehub"]),
    goBack() {
      window.history.back();
    },
    getLanguage(langt) {
      setTimeout(() => {
        if (langt != "") {
          if (langt != "english") {
            if (this.details[`cont_name_${langt}`] != "") {
              document.getElementById("cont_name").innerHTML = this.details[
                `cont_name_${langt}`
              ];
            } else {
              document.getElementById("cont_name").innerHTML = this.details[
                `cont_name_english`
              ];
            }

            if (this.details[`desc_${langt}`] != "") {
              document.getElementById("description").innerHTML = `<span>${
                this.details[`desc_${langt}`]
              }</span>`;
            } else {
              document.getElementById("description").innerHTML = `<span>${
                this.details[`desc_english`]
              }</span>`;
            }
          } else {
            document.getElementById("cont_name").innerHTML = this.details[
              `cont_name_english`
            ];
            document.getElementById("description").innerHTML = `<span>${
              this.details[`desc_english`]
            }</span>`;
          }

          let platform = "";
          let plat = require(`../../locales/cutehub/${langt}.json`);
          let file = this.details.content_detail.split(".");
          if (file[1] == "apk" || this.details.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }

          document.getElementById("platform").innerHTML = platform;
          document.getElementById("category").innerHTML = this.details[
            `titleSub_${langt}`
          ];
        }
      }, 0);
    },
    initPlyr() {
      const vidPlyrr = new Plyr(document.getElementById("vidPlayer"));
    },
    getDetails(id) {
      let local = `http://[::1]/PuretechGlobalContentPortal`;
      let live = `http://cook.grabmobi.com`;
      
      //everytime user display detail page, will collect the data
      axios.post(`${live}/api/newcontents_statistic`, {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_cutehub,
        product: 'cutehub',
        content_id: id,
        type: "view"
      })
      
      axios.get(`${live}/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=${id}&category=&subcategory=&limit=100&offset=0&domain=${this.host_cutehub}`).then((res) => {
        let data = res.data.data[0];

        let sc = data.screenshot.split(",");
        let sc_temp = [];
        for (let i = 0; i < sc.length; i++) {
          sc_temp.push({ id: i, url: `${this.srcUrl}/${data.id}/${sc[i]}` });
        }

        data.screenshot = sc_temp;
        this.contentCoverImg = data.cover_img;
        data.titleSub_english = data.subcategory;

        if (data.subcategory_translate != null) {
          let sub_trans = JSON.parse(data.subcategory_translate);
          let sub_icon = JSON.parse(data.subcategory_icon);

          let trans_len = Object.keys(sub_trans).length;
          let trans_arr = Object.keys(sub_trans);

          for (let i = 0; i < trans_len; i++) {
            data["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
          }
        }

        if (data.category == "Wallpaper") {
          data.content_type = "wallpaper/zip";
        }

        setTimeout(() => {
          this.details = data;
          this.isLoad = true;
          this.$nextTick(() => {
            this.initPlyr();
          });
        }, 0);
      });
    },
    openLightBox(d) {
      this.lightBoxCurrentPic = d.url;
      this.lightBoxCurrentId = d.id;
      this.lightBoxToggle = !this.lightBoxToggle;
    },
    nextPic() {
      this.lightBoxCurrentId += 1;
      if (this.lightBoxCurrentId < this.details.screenshot.length) {
        this.lightBoxCurrentPic = this.details.screenshot[
          this.lightBoxCurrentId
        ].url;
      } else {
        this.lightBoxCurrentId = this.details.screenshot.length - 1;
      }
    },
    prevPic() {
      if (this.lightBoxCurrentId > 0) {
        this.lightBoxCurrentId -= 1;
        this.lightBoxCurrentPic = this.details.screenshot[
          this.lightBoxCurrentId
        ].url;
      }
    },
    closeBox() {
      this.lightBoxToggle = false;
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/");
      const fromDepth = from.path.split("/");
      if (from.name == "DetailPage") {
        this.getDetails(this.$route.params.id);
      }
    },
  },
};
</script>

<style  lang="scss">
.contentDetail {
  color: #fff;
  /* padding: 25px 50px; */
  margin: 0 auto;
  max-width: 1024px;
  width: 100%;
  transform: none !important;
  .mobiTitle {
    color: #fff;
  }
}

.detail_main .detail_wrp {
  margin: 5px;
  color: black;
}
.contentCover {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.53);
  }
}
.contentDetail__icon {
  width: 160px;
  height: 160px;
  overflow: hidden;
  position: relative;
  border-radius: 24px;
  margin-bottom: 25px;
  img {
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .mobibadge {
    right: 0;
    bottom: 0;
    top: auto;
  }
}

.contentDetail__info {
  width: 100%;
  .mobitxt {
    max-width: 580px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 25px 0;
    direction: ltr;
    li {
      margin: 15px 0;
      font-weight: 500;
      font-size: 1.2rem;
    }
  }
}
.videoPlayer {
  width: 100%;
  height: 420px;
  max-width: 1024px;
  margin: 0 auto 25px;
  .plyr__poster {
    background-size: cover;
  }
}
.videoPlayer .plyr audio,
.videoPlayer .plyr video {
  height: 420px;
}
.cutehub {
  .videoPlayer .plyr__control--overlaid {
    background: #ed215e;
  }
}

video#vidPlayer {
  width: 100%;
}
.contentDetails__screens {
  ul {
    img {
      width: 100%;
    }
    li {
      display: inline-block;
      width: 25%;
      margin-right: 15px;
      img {
        width: 100%;
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .contentDetail {
    color: #fff;
    padding: 25px 0px;
    text-align: center;
  }
  .contentDetail__info {
    text-align: left;
  }
  .contentDetail__icon {
    margin: 0 auto;
  }
  .contentDetails__screens ul li {
    width: 33%;
  }
}
@media only screen and (max-width: 589px) {
  .contentDetails__screens ul li {
    width: 100%;
    height: 220px;
    overflow: hidden;
    img {
      height: 220px;
      object-fit: cover;
      object-position: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cutehub/DetailPage.vue